import smoothscroll from 'smoothscroll-polyfill';

export default {
    _target: null,
    _toggle: null,
    _regions : null,
    _reports: null,
    _filter: null,

    init() {
        this._toggle = document.querySelectorAll('[data-regions-toggle]');
        this._target = document.querySelectorAll('[data-regions-target]');
        this._reports = document.querySelectorAll('[data-regions-report]');
        this._filter = document.querySelector('[data-progress-filter]');
        
        if (!(this._toggle)) {
            return;
        }
        smoothscroll.polyfill();

        let url = window.location.href;
        if(url.indexOf("kommune") > -1) {
            this._filter.scrollIntoView({block: "start"})
        }
        for(const toggle of this._toggle){
            toggle.addEventListener(('click'), () => {
                for (const target of this._target){
                    if(target.getAttribute('data-regions-target') === toggle.getAttribute('data-regions-toggle') ){
                        const targerClass = target.classList[0] +'--active';
                        target.classList.toggle(targerClass);
                        this._regions = target.querySelectorAll('[data-region]');
                        for (const region of this._regions){
                            region.addEventListener(('click'), () => {
                                for (const report of this._reports){
                                    const targetClass=report.classList[0]+'--active';
                                    if(report.getAttribute('data-regions-report') === region.getAttribute('data-region')){
                                        report.classList.add(targetClass);
                                        let focused = report.querySelector('.focus');
                                        if(screen.width < 500){
                                            focused.scrollIntoView({behavior: "smooth", block: "nearest", inline: "center"})
                                        }
                                    }
                                    else{
                                        report.classList.remove(targetClass);
                                    }
                                }
                            toggle.innerHTML = region.innerHTML;
                            toggle.classList.add('selected');
                            target.classList.remove(targerClass);
                            });
                        }
                    }
                }
            });
        }
    }
}